export const SET_LOADING_DATA = '@mandatoryMix/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@mandatoryMix/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@mandatoryMix/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@mandatoryMix/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@mandatoryMix/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@mandatoryMix/GET_BY_ID_SUCCESS';

export const GET_FILTER_PRODUCT_REQUEST = '@mandatoryMix/GET_FILTER_PRODUCT_REQUEST';
export const GET_FILTER_PRODUCT_SUCCESS = '@mandatoryMix/GET_FILTER_PRODUCT_SUCCESS';

export const SAVE_REQUEST = '@mandatoryMix/SAVE_REQUEST';
export const SAVE_SUCCESS = '@mandatoryMix/SAVE_SUCCESS';

export const DELETE_ITEM = '@mandatoryMix/DELETE_ITEM';
export const EDIT_ITEM = '@mandatoryMix/EDIT_ITEM';

export const SEARCH = '@mandatoryMix/SEARCH';

export const SET_PAGE = '@mandatoryMix/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@mandatoryMix/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@mandatoryMix/SET_ORDER';
export const SET_ORDERBY = '@mandatoryMix/SET_ORDEBY';
